// extracted by mini-css-extract-plugin
export default {"container":"oO-z","title":"pO-z","link":"qO-z"};